import gql from 'graphql-tag';
import { DocumentFragments } from '@signing-page/api/documents/graphql/document.fragments';
import { videoFragment } from '@signing-page/api/video/graphql/video.fragment';

export const documentQuery = gql`
  query Document {
    document {
      expirationDate
      id
      isAutoComment
      isSigning
      isSigningOrder
      isVideo
      isSigningInitials
      name
      status
      type
      value
      sendDate
      signDate
      nextRecipientIdToSign
      nextRecipientsInLine {
        ...recipientFragment
      }
      uniqueId
      documentAttachments {
        id
        requireView
        previewUrl
        lastView
        lastUpload
        createdAt
        attachment {
          id
          attachmentTitle
          attachmentDescription
          attachmentType
          attachmentUrl
          attachmentFilename
        }
      }
      user {
        ...userFragment
      }
      recipients {
        ...recipientFragment
      }
      pages {
        ...pageFragment
      }
      manuallySignedPages {
        ...signaturePageFragment
      }
      video {
        ...videoFragment
      }
      documentVideos {
        ...videoFragment
      }
      activeTwilioIntegration
      isSigningForward
      documentRevisions {
        message
        revision
        status
        createdAt
        viewedByRecipient
      }
    }
  }
  ${DocumentFragments.userFragment}
  ${DocumentFragments.recipientFragment}
  ${DocumentFragments.pageFragment}
  ${DocumentFragments.signaturePageFragment}
  ${videoFragment}
`;

export const documentRevisionsQuery = gql`
  query Document {
    document {
      documentRevisions {
        message
        revision
        status
        createdAt
        viewedByRecipient
      }
    }
  }
`;

export const getDownloadUrlQuery = gql`
  query getDownloadUrl {
    getDownloadUrl
  }
`;

export const recipientsQuery = gql`
  query Document {
    document {
      id
      recipients {
        ...recipientFragment
      }
    }
  }
  ${DocumentFragments.recipientFragment}
`;
